import { LabelMasterStatusEnum } from '@ulysses-inc/harami_api_client'

export type LabelMasterForm = {
  name: string
  code: string
  barcodeId: string
  status: LabelMasterStatusEnum
}

export const labelMasterFormDefaultValues: LabelMasterForm = {
  name: '',
  code: '',
  barcodeId: '',
  status: LabelMasterStatusEnum.VALID,
}
